<script>
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import {lookup2,disabledBeforeTodayDates,downFile} from '@/apis/common'
import {saveOrder} from '@/apis/order'
import LanguageSwitch from '../../components/language-switch';
import {publicUpload} from '@/apis/file'
import {
  required,numeric
} from "vuelidate/lib/validators";
/**
 * Form Repeater component
 */
export default {
  page: {
    title: "Online Information Collection Form",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout,DatePicker,LanguageSwitch,Multiselect},
  validations: {
    form: {
      clientName: { 
            required,
      },
      country: { 
        required,
      },
      address: { 
            required,
      },
      contact: { 
            required,
      },
      mobile: { 
            required,
      },
      email: { 
            required,
      },
      companyInfo:{
          employee:{
            required,
            numeric
          }      
      },
      orderDetail:{
        auditDateFrom:{
          required
        },
        auditDateTo:{
          required
        },
        attachment:{
          required
        }
      }
    },
  },
  props:{
    sales:{
      type: String,
      required: false
    }
  },
  data() {
    return {
      title: "Online Information Collection Form",
      orderNo:null,
      clientNo:null,
      disabledDates: disabledBeforeTodayDates,
      showTaxCode:false,
      form:{
        orderId:null,
        orderType:"FPA",
        orderSource:"WP",
        orderStatus:'N',
        paymentStatus:'Y',
        orderDetail:{
          type:"Step 1",
          model:"Onsite",
          experience:"3",
          experienceNum:"1",
          announcementType:"3",
          days:"15",
          auditDateFrom:"",
          auditDateTo:"",
          contactListSc:[
          {
            contact:"",
            email:"",
            mobile:"",
            title:"",
          }
          ],
          contactListReport:[
          {
            contact:"",
            email:"",
            mobile:"",
            title:"",
          }
          ],          
          contactListAlert:[
          {
            contact:"",
            email:"",
            mobile:"",
            title:"",
          }
          ],                 
          attachment:"",
          attachmentFileName:"",
          specialNotes:""
        },
        clientId:null,
        clientName:"",
        clientNameEn:"",
        country:"",
        province:"",
        city:"",
        station:"",
        address:"",
        addressEn:"",
        companyInfo:{
          employee:"",
          manager:"",
        },
        contact:"",
        email:"",
        mobile:"",
        title:"",
        department:"",
        salesTag:"",
      },
      submitted:false,
      success:false,
      lookupRawData:{},
      lookupData:{
        cnty:{},
      },
      lookupDataSelected:{
        cnty:[]
      },
    };
  },
  created(){
    if(this.$route.query.tag!=undefined){
      this.form.salesTag = this.$route.query.tag;
    }
    this.init();
  },
  watch:{
    "lookupDataSelected.cnty"(){
      if(this.lookupDataSelected.cnty.value!=undefined){
        this.form.country = this.lookupDataSelected.cnty.value
      }
    },
    "form.address"(){
      if(this.form.address.indexOf("省")!=-1||this.form.address.indexOf("市")!=-1){
        let address = this.form.address.replace("，",",").split("市")[0].replace("中国","").trim()
        if(address.indexOf("省")!=-1){
          let province_city = address.split("省")
          this.form.city = ""||province_city[1].trim()
        }else{
          this.form.city = address
        }
      }
    },    
  },
  methods: {
    async init(){
      // 初始化数据字典
      this.lookupRawData = await lookup2("CNTY");
      this.lookupData.cnty = this.lookupRawData["CNTY"].map(item=>{return {...item,labelCn:item.label}});
      this.changeLookupLanguage()
    },
    changeLookupLanguage(){
      if(localStorage.getItem('language')=="zh-CN"){
        this.showTaxCode = false;
        this.lookupData.cnty = this.lookupData.cnty.map(item=>{return {...item,label:item.labelCn}});
      }else{
        this.showTaxCode = true;
        this.lookupData.cnty = this.lookupData.cnty.map(item=>{return {...item,label:item.labelEn}});
      }
    },
    handleSaveClient() {
      this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
            this.success = false
            return;
        } else {
          let params = {...this.form}
          params.companyInfo = JSON.stringify(this.form.companyInfo)
          params.orderDetail = JSON.stringify(this.form.orderDetail)
          params.sales = this.sales
          params.language = localStorage.getItem('language')
          if(this.lookupDataSelected.cnty.value!=undefined){
            params.country = this.lookupDataSelected.cnty.value
          }
          this.success = true
          saveOrder('FPA',params).then(()=>{
            Swal.fire(this.$t("common.successMsg"),"", "success");
          }).catch(()=>{
            this.success = false
          })
        }
    },
    handleSaveFormFile(){
        this.$refs.attachment.click()
    },
    changeAttachmentFile(){
        if(this.$refs.attachment.files.length==1){
          const formData = new FormData();
          formData.append("files",this.$refs.attachment.files[0]);
          formData.append("type","orderAttachment");
          publicUpload(formData).then((res)=>{
            this.form.orderDetail.attachment = res.data[0].fileOrgName
            this.form.orderDetail.attachmentFileName = res.data[0].fileName
          })
        }
    },  
    handleGoHome(){
      this.$router.push({
          name: 'home',
      })
    },
    handleDownload (){
        const url=`/api-gateway/service/download?fileType=SERVICE&fileName=${this.form.orderDetail.attachment}`
        downFile(url,this.form.orderDetail.attachmentFileName);
    },
    handleNewContact(cType){
      if(cType=="SC"){
        this.form.orderDetail.contactListSc.push({
        contact:"",
        email:"",
        mobile:"",
        title:"",
      })
      }else if(cType=="RP"){
        this.form.orderDetail.contactListReport.push({
        contact:"",
        email:"",
        mobile:"",
        title:"",
      })
      }else if(cType=="AT"){
        this.form.orderDetail.contactListAlert.push({
        contact:"",
        email:"",
        mobile:"",
        title:"",
      })
      }
    },
    deleteContact(cType,index){
      if(cType=="SC"){
        this.form.orderDetail.contactListSc.splice(index, 1);
      }else if(cType=="RP"){
        this.form.orderDetail.contactListReport.splice(index, 1);
      }else if(cType=="AT"){
        this.form.orderDetail.contactListAlert.splice(index, 1);
      }      
      
    }
  },
};
</script>

<template>
  <Layout>
    <div class="row  mt-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" style="padding-top: 0px;">
                        <div class="row">
                          <div class="col-lg-2 col-sm-1 logo-col" >
                            <a href="http://www.greenpont.com/" class="logo">
                                <span class="logo-sm">
                                  <img src="@/assets/images/logo-sm.svg" alt height="22" />
                                </span>
                                <span class="logo-lg">
                                  <img src="@/assets/images/logo-dark.svg" alt height="36" />
                                </span>
                            </a>
                          </div>
                          <div class="col-lg-8 col-sm-10 text-center" >
                            <h5 class="card-title" style="line-height: 70px;"><span class="logo-icon">
                              <a href="http://www.greenpont.com/"><img src="@/assets/images/logo-sm.svg" alt height="22" /></a>
                              </span>{{ $t("fpa.formName") }}</h5>
                          </div>
                        </div>
                        <language-switch @change="changeLookupLanguage"></language-switch>
                        <form class="needs-validation">
                          <div class="card border shadow-none mb-5">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar">
                                            <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{ $t("fpa.auditRequirement") }}</h5>
                                    </div>
                                </div>
                                <div class="card-body">
                                  <div class="mb-3">
                                  <label class="form-label mb-3 d-flex">{{ $t("fpa.experience") }}:</label>
                                  <input type="text" class="form-control form-control-sm" style="width:100px;display: inline;"  id="experienceNum" v-model="form.orderDetail.experienceNum">{{ $t("slcp.times") }}
                                </div>
                                <div class="mb-3">
                                  <label class="form-label mb-3 d-flex">{{ $t("slcp.announcementType") }}:</label>
                                  <div class="form-check form-check-inline">
                                    <input
                                      type="radio"
                                      id="announcementType1"
                                      name="announcementType"
                                      class="form-check-input"
                                      value="1"
                                      v-model="form.orderDetail.announcementType"
                                    />
                                    <label class="form-check-label" for="announcementType1">{{ $t("slcp.announcementType1") }}</label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                    <input
                                      type="radio"
                                      id="announcementType2"
                                      name="announcementType"
                                      class="form-check-input"
                                      value="2"
                                      v-model="form.orderDetail.announcementType"
                                    />
                                    <label class="form-check-label" for="announcementType2">{{ $t("slcp.announcementType2") }}</label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                    <input
                                      type="radio"
                                      id="announcementType3"
                                      name="announcementType"
                                      class="form-check-input"
                                      value="3"
                                      v-model="form.orderDetail.announcementType"
                                    />
                                    <label class="form-check-label" for="announcementType3">{{ $t("fpa.announcementType3") }} &nbsp;&nbsp;</label>
                                    <input type="text" class="form-control form-control-sm" style="width:100px;display: inline;" placeholder="days" id="days" v-model="form.orderDetail.days">
                                  </div>
                                </div>
                                <div class="mb-3">
                                  <label class="form-label">{{ $t("fpa.auditDate") }} :</label>
                                  <div class="row">
                                    <div class="col-md-6">
                                      <date-picker
                                        v-model="form.orderDetail.auditDateFrom"
                                        format="YYYY-MM-DD"
                                        value-type="format"
                                        :disabled-date="disabledDates"
                                        :first-day-of-week="1"
                                        lang="en"
                                        placeholder="from"
                                        :class="{
                                            'is-invalid': submitted && $v.form.orderDetail.auditDateFrom.$error,
                                        }"
                                      ></date-picker>
                                      <div
                                          v-if="submitted && $v.form.orderDetail.auditDateFrom.$error"
                                          class="invalid-feedback"
                                          >
                                              <span v-if="!$v.form.orderDetail.auditDateFrom.required">
                                                {{ $t("fpa.auditDateError") }}.
                                              </span>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <date-picker
                                        v-model="form.orderDetail.auditDateTo"
                                        format="YYYY-MM-DD"
                                        value-type="format"
                                        :disabled-date="disabledDates"
                                        :first-day-of-week="1"
                                        lang="en"
                                        placeholder="to"
                                        :class="{
                                            'is-invalid': submitted && $v.form.orderDetail.auditDateTo.$error,
                                        }"
                                      ></date-picker>
                                      <div
                                          v-if="submitted && $v.form.orderDetail.auditDateTo.$error"
                                          class="invalid-feedback"
                                          >
                                              <span v-if="!$v.form.orderDetail.auditDateTo.required">
                                                {{ $t("fpa.auditDateError") }}.
                                              </span>
                                      </div>
                                    </div>
                                  </div>                        
                                </div>
                                <div class="row">
                                  <label class="form-label mb-3 d-flex">{{ $t("fpa.attachment") }}:</label>                                  
                                    <div class="col-md-5 mb-3">
                                        <input type="text" class="form-control"  v-model="form.orderDetail.attachmentFileName" disabled 
                                        :class="{
                                            'is-invalid': submitted && $v.form.orderDetail.attachment.$error,
                                        }"                    
                                        />
                                        <div
                                            v-if="submitted && $v.form.orderDetail.attachment.$error"
                                            class="invalid-feedback"
                                            >
                                                <span v-if="!$v.form.orderDetail.attachment.required">
                                                    {{$t("common.requiredError")}}.
                                                </span>
                                        </div>       
                                    </div>                
                                    <div class="col-md-3 mb-3">
                                        <button type="button" class="btn btn-info" @click="handleSaveFormFile">{{$t("common.selectFile")}}</button>
                                        <button v-if="form.orderDetail.attachment!=''" type="button" class="btn btn-info ms-1" @click="handleDownload('ORDER',form.orderDetail.attachment,form.orderDetail.attachmentFileName)">{{$t("common.download")}}</button> 
                                    </div>    
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="serviceProvider">{{$t("fpa.specialNotes")}}</label>
                                    <textarea class="form-control" id="specialNotes" v-model="form.orderDetail.specialNotes"></textarea>         
                                </div>
                                </div>
                            </div>
                            <div class="card border shadow-none mb-5">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar">
                                            <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                                02
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{$t("common.baseInfo")}}</h5>
                                    </div>
                                </div>
                                <div class="card-body">
                                  <div class="row">
                                    <div class="col-lg-6 mb-3">
                                            <label class="form-label" for="gen-info-name-input">{{$t("common.clientNameLocal")}}</label>
                                            <input type="text" class="form-control" id="gen-info-name-input" v-model="form.clientName"
                                            :class="{
                                                    'is-invalid': submitted && $v.form.clientName.$error,
                                                }">
                                            <div
                                                v-if="submitted && $v.form.clientName.$error"
                                                class="invalid-feedback"
                                                >
                                                    <span v-if="!$v.form.clientName.required">
                                                      {{$t("common.clientNameLocalError")}}.
                                                    </span>
                                            </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="mb-3">
                                            <label class="form-label" for="gen-info-name-en-input">{{$t("common.clientNameEn")}}</label>
                                            <input type="text" class="form-control" id="gen-info-name-en-input" v-model="form.clientNameEn">
                                        </div>
                                    </div>
                                </div>            
                                <div class="row">
                                    <div class="col-lg-6 mb-3">
                                      <label class="form-label" for="gen-info-country-input">{{$t("common.country")}}</label>
                                        <multiselect 
                                        id="gen-info-country-input"
                                        v-model="lookupDataSelected.cnty" 
                                        :options="lookupData.cnty"
                                        label="label"
                                        track-by="value"
                                        :class="{
                                                'is-invalid': submitted && $v.form.country.$error,
                                            }"
                                        ></multiselect>
                                        <div
                                            v-if="submitted && $v.form.country.$error"
                                            class="invalid-feedback"
                                            >
                                                <span v-if="!$v.form.country.required">
                                                  {{$t("common.countryError")}}.
                                                </span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 mb-3">
                                            <label class="form-label" for="gen-info-province-input">{{$t("common.province")}}</label>
                                            <input type="text" class="form-control" id="gen-info-province-input" v-model="form.province">
                                    </div>                              
                                </div>     
                                <div class="row">
                                    <div class="col-lg-6 mb-3">
                                            <label class="form-label" for="gen-info-address-input">{{$t("common.addressLocal")}}</label>
                                            <input type="text" class="form-control" id="gen-info-address-input"  v-model="form.address"
                                            :class="{
                                                    'is-invalid': submitted && $v.form.address.$error,
                                                }">
                                            <div
                                                v-if="submitted && $v.form.address.$error"
                                                class="invalid-feedback"
                                                >
                                                    <span v-if="!$v.form.address.required">
                                                      {{$t("common.addressLocalError")}}.
                                                    </span>
                                            </div>                                        
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="mb-3">
                                            <label class="form-label" for="gen-info-address-en-input">{{$t("common.addressEn")}}</label>
                                            <input type="text" class="form-control" id="gen-info-address-en-input" v-model="form.addressEn">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 mb-3">
                                            <label class="form-label" for="employee">{{$t("slcp.employee")}}</label>
                                            <input type="text" class="form-control" id="employee" v-model="form.companyInfo.employee">
                                    </div>
                                    <div class="col-lg-6 mb-3">
                                            <label class="form-label" for="managers">{{$t("slcp.manager")}}</label>
                                            <input type="text" class="form-control" id="managers"  v-model="form.companyInfo.manager">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 mb-3">
                                            <label class="form-label" for="gen-info-contact-input">{{$t("common.contact")}}</label>
                                            <input type="text" class="form-control" id="gen-info-contact-input" v-model="form.contact"
                                            :class="{
                                                'is-invalid': submitted && $v.form.contact.$error,
                                            }">
                                            <div
                                                v-if="submitted && $v.form.contact.$error"
                                                class="invalid-feedback"
                                                >
                                                    <span v-if="!$v.form.contact.required">
                                                      {{$t("common.contactError")}}.
                                                    </span>
                                            </div>
                                    </div>
                                    <div class="col-lg-6 mb-3">
                                      <label class="form-label" for="gen-info-title-input">{{$t("common.title")}}</label>
                                            <input type="text" class="form-control" id="gen-info-title-input" v-model="form.title">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 mb-3">
                                            <label class="form-label" for="gen-info-mobile-input">{{$t("common.mobile")}}</label>
                                            <input type="text" class="form-control" id="gen-info-mobile-input" v-model="form.mobile"
                                            :class="{
                                                'is-invalid': submitted && $v.form.mobile.$error,
                                            }">
                                            <div
                                                v-if="submitted && $v.form.mobile.$error"
                                                class="invalid-feedback"
                                                >
                                                    <span v-if="!$v.form.mobile.required">
                                                      {{$t("common.mobileError")}}.
                                                    </span>
                                            </div>
                                    </div>
                                    <div class="col-lg-6 mb-3" >
                                            <label class="form-label" for="gen-info-email-input">{{$t("common.email")}}</label>
                                            <input type="text" class="form-control" id="gen-info-email-input"  v-model="form.email"
                                            :class="{
                                                'is-invalid': submitted && $v.form.email.$error,
                                            }">
                                            <div
                                                v-if="submitted && $v.form.email.$error"
                                                class="invalid-feedback"
                                                >
                                                    <span v-if="!$v.form.email.required">
                                                      {{$t("common.emailError")}}.
                                                    </span>
                                            </div>
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div class="card border shadow-none mb-3">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar">
                                            <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                                03
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{$t("fpa.contactSC")}}</h5>
                                    </div> 
                                    <button type="button" class="btn btn-success btn-sm" @click="handleNewContact('SC')">{{$t("actions.add")}}</button>                                   
                                </div>
                                <div class="card-body">
                                  <div class="row"
                                  v-for="(data, index) in form.orderDetail.contactListSc"
                                  :key="data.email"                                  
                                  >
                                    <div class="col-lg-3 mb-3">
                                            <label class="form-label">{{$t("common.contact")}}{{index+1}}</label>
                                            <input type="text" class="form-control" id="gen-info-contact-input" v-model="data.contact">
                                    </div>
                                    <div class="col-lg-3 mb-3">
                                            <label class="form-label">{{$t("common.mobile")}}</label>
                                            <input type="text" class="form-control" id="gen-info-mobile-input" v-model="data.mobile">
                                    </div>
                                    <div class="col-lg-4 mb-3" >
                                            <label class="form-label">{{$t("common.email")}}</label>
                                            <input type="text" class="form-control" id="gen-info-email-input"  v-model="data.email">
                                    </div>
                                    <div class="col-lg-2 mb-3">
                                      <label class="form-label" >&nbsp;</label>
                                        <input
                                        type="button"
                                        class="form-control btn btn-primary btn-block btn-sm"
                                        :value='$t("actions.delete")'
                                        @click="deleteContact('SC',index)"
                                        v-if="index>0"
                                      />
                                    </div>                                    
                                </div>
                              </div>
                            </div>
                            <div class="card border shadow-none mb-3">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar">
                                            <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                                04
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{$t("fpa.contactRP")}}</h5>
                                    </div> 
                                    <button type="button" class="btn btn-success btn-sm" @click="handleNewContact('RP')">{{$t("actions.add")}}</button>                                   
                                </div>
                                <div class="card-body">
                                  <div class="row"
                                  v-for="(data, index) in form.orderDetail.contactListReport"
                                  :key="data.email"                                  
                                  >
                                    <div class="col-lg-3 mb-3">
                                            <label class="form-label">{{$t("common.contact")}}{{index+1}}</label>
                                            <input type="text" class="form-control" v-model="data.contact">
                                    </div>
                                    <div class="col-lg-3 mb-3">
                                            <label class="form-label">{{$t("common.mobile")}}</label>
                                            <input type="text" class="form-control"  v-model="data.mobile">
                                    </div>
                                    <div class="col-lg-4 mb-3" >
                                            <label class="form-label">{{$t("common.email")}}</label>
                                            <input type="text" class="form-control"  v-model="data.email">
                                    </div>
                                    <div class="col-lg-2 mb-3">
                                      <label class="form-label" >&nbsp;</label>
                                        <input
                                        type="button"
                                        class="form-control btn btn-primary btn-block btn-sm"
                                        :value='$t("actions.delete")'
                                        @click="deleteContact('RP',index)"
                                        v-if="index>0"
                                      />
                                    </div>                                    
                                </div>
                              </div>
                            </div>
                            <div class="card border shadow-none mb-3">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar">
                                            <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                                05
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{$t("fpa.contactAT")}}</h5>
                                    </div> 
                                    <button type="button" class="btn btn-success btn-sm" @click="handleNewContact('AT')">{{$t("actions.add")}}</button>                                   
                                </div>
                                <div class="card-body">
                                  <div class="row"
                                  v-for="(data, index) in form.orderDetail.contactListAlert"
                                  :key="data.email"                                  
                                  >
                                    <div class="col-lg-3 mb-3">
                                            <label class="form-label">{{$t("common.contact")}}{{index+1}}</label>
                                            <input type="text" class="form-control"  v-model="data.contact">
                                    </div>
                                    <div class="col-lg-3 mb-3">
                                            <label class="form-label">{{$t("common.mobile")}}</label>
                                            <input type="text" class="form-control"  v-model="data.mobile">
                                    </div>
                                    <div class="col-lg-4 mb-3" >
                                            <label class="form-label">{{$t("common.email")}}</label>
                                            <input type="text" class="form-control" v-model="data.email">
                                    </div>
                                    <div class="col-lg-2 mb-3">
                                      <label class="form-label" >&nbsp;</label>
                                        <input
                                        type="button"
                                        class="form-control btn btn-primary btn-block btn-sm"
                                        :value='$t("actions.delete")'
                                        @click="deleteContact('AT',index)"
                                        v-if="index>0"
                                      />
                                    </div>                                    
                                </div>
                              </div>
                            </div>                                                        
                          </form>
                          <div>
                              <button type="button" class="btn btn-primary w-sm"  @click="handleSaveClient" :disabled="success">{{$t("common.submit")}}</button> {{$t("common.hotline")}}: +86 755 21608956/ +84 932 130 677
                              <button type="button" class="btn btn-btn-secondary w-sm" @click="handleGoHome" v-if="false">{{$t("common.moreService")}}</button>
                          </div>
                    </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <input ref="attachment" type="file" aria-label="Upload your file" placeholder="" style="display: none;" @change="changeAttachmentFile">
    <!-- end row -->
  </Layout>
</template>
<style lang="scss">
.is-invalid .mx-input-wrapper .mx-input{
    border: 1px solid #ec4561 !important;
  }
  .is-invalid .mx-input-wrapper .mx-icon-calendar{
    color: #ec4561 !important;
  }
  .is-invalid .multiselect__tags{
    border:1px solid #ec4561 !important;
  }
</style>
